"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _pixelToNumber = _interopRequireDefault(require("../../../style/pixelToNumber"));

function _default(theme) {
  var palette = theme.palette;
  return {
    idleBorderWidth: 0,
    hoverBorderWidth: 0,
    focusBorderWidth: 0,
    errorBorderWidth: 0,
    disabledBorderWidth: 0,
    lineHeight: (0, _pixelToNumber["default"])(theme.balanceLineHeight) + (0, _pixelToNumber["default"])(theme.lineHeight) + 2 + 'px',
    paddingTop: 0,
    paddingBottom: 0,
    listItemPaddingTop: palette.gutter + 'px',
    listItemPaddingBottom: palette.gutter + 'px',
    listItemPaddingLeft: palette.gutter * 2 + 'px',
    listItemPaddingRight: palette.gutter * 2 + 'px',
    listOffsetRight: palette.gutter * 2 * -1,
    listOffsetLeft: palette.gutter * 2 * -1
  };
}